import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { openCreatorPlanUpgradeDialog } from "src/app/shared/utils/creator-plan-restrictions.util";
import {
  resolveCoinPurchaseReturnUrl,
  setCoinPurchaseReturnUrl,
} from "src/app/shared/utils/coin-purchase-return.util";
export function isMaxPublishedFlowsError(err: unknown): boolean {
  const e = err as { status?: number; error?: { code?: string } };
  return e?.status === 403 && e?.error?.code === "max_published_flows";
}

export function isFlowBundlePermissionError(err: unknown): boolean {
  const e = err as { status?: number; error?: { code?: string } };
  return e?.status === 403 && e?.error?.code === "permission_required";
}

export function handleFlowBundlePermissionError(toastr: ToastrService, err?: unknown): void {
  const message =
    (err as { error?: { message?: string } })?.error?.message ||
    "Currently you do not have access to create flow/bundle please request access to admin";
  toastr.info(message);
}

export function isCreatorPublicOnlyError(err: unknown): boolean {
  const e = err as { status?: number; error?: { code?: string } };
  return e?.status === 403 && e?.error?.code === "creator_public_only";
}

export function handleCreatorPublicOnlyError(
  dialog: MatDialog,
  returnUrl?: string | null,
  err?: unknown
): void {
  openCreatorPlanUpgradeDialog(dialog, returnUrl);
}

export function handleMaxPublishedFlowsError(
  router: Router,
  toastr: ToastrService,
  err: unknown,
  returnUrl?: string | null
): void {
  const message =
    (err as { error?: { message?: string } })?.error?.message ||
    "Your included guide limit is used. Purchase a guide top-up pack to publish more.";
  toastr.warning(message, "Guide limit reached");
  const target = resolveCoinPurchaseReturnUrl(returnUrl || router.url);
  if (target) {
    setCoinPurchaseReturnUrl(target);
  }
  router.navigate(["/pricing"], {
    queryParams: { buyGuides: "1", returnUrl: target || undefined },
    fragment: "guide-topups",
  });
}
